import { Flex } from 'foundations-components/components/Flex';
import { Link } from 'foundations-components/transitional/components/Link';
import { getUsersSeatsUrl } from '../../urls/getUsersSeatsUrl';
import { useTrackUsageContext } from '../../usage-tracking/contexts/TrackUsageContext';
import { trackClickManageSeats } from '../utils/event-handlers';
import { jsx as _jsx } from "react/jsx-runtime";
export const ManageSeatsLink = ({
  children
}) => {
  const trackUsage = useTrackUsageContext();
  return /*#__PURE__*/_jsx(Flex, {
    as: "span",
    flexWrap: "nowrap",
    display: "inline-flex",
    children: /*#__PURE__*/_jsx(Link, {
      external: true,
      href: getUsersSeatsUrl(),
      onClick: () => trackUsage(trackClickManageSeats()),
      children: children
    })
  });
};
ManageSeatsLink.displayName = 'ManageSeatsLink';